/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateGcpKmsKeyRequestBody,
  UpdateGcpKmsKeyRequestBody$Outbound,
  UpdateGcpKmsKeyRequestBody$outboundSchema,
} from "../components/updategcpkmskeyrequestbody.js";

export type UpdateGcpKmsKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateGcpKmsKeyRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateGcpKmsKeyRequestBody: UpdateGcpKmsKeyRequestBody;
};

/** @internal */
export type UpdateGcpKmsKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateGcpKmsKeySecurity$outboundSchema: z.ZodMiniType<
  UpdateGcpKmsKeySecurity$Outbound,
  UpdateGcpKmsKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateGcpKmsKeySecurityToJSON(
  updateGcpKmsKeySecurity: UpdateGcpKmsKeySecurity,
): string {
  return JSON.stringify(
    UpdateGcpKmsKeySecurity$outboundSchema.parse(updateGcpKmsKeySecurity),
  );
}

/** @internal */
export type UpdateGcpKmsKeyRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateGcpKmsKeyRequestBody: UpdateGcpKmsKeyRequestBody$Outbound;
};

/** @internal */
export const UpdateGcpKmsKeyRequest$outboundSchema: z.ZodMiniType<
  UpdateGcpKmsKeyRequest$Outbound,
  UpdateGcpKmsKeyRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    updateGcpKmsKeyRequestBody: UpdateGcpKmsKeyRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      updateGcpKmsKeyRequestBody: "UpdateGcpKmsKeyRequestBody",
    });
  }),
);

export function updateGcpKmsKeyRequestToJSON(
  updateGcpKmsKeyRequest: UpdateGcpKmsKeyRequest,
): string {
  return JSON.stringify(
    UpdateGcpKmsKeyRequest$outboundSchema.parse(updateGcpKmsKeyRequest),
  );
}
